<template>
    <Bank :id="Number(0)"/>
</template>
<script>
import Bank from '@/components/BankCredits.vue';

export default {
    components: {
        Bank
    }
}
</script>